import Bugsnag from '@bugsnag/js';

const onError = (error, opts = {}) => {
  if (error.ignoreIfHandled) {
    return;
  }

  if (process.env.NODE_ENV === 'development') {
    console.error(error); // eslint-disable-line no-console
  }

  Bugsnag.notify(error, opts);
};

export default onError;
